import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import TablePagination from "@material-ui/core/TablePagination";
import DatePicker from "react-datepicker";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import CustomPaginatorActions from "../components/CustomPaginatorActions";
import ConfirmDialog from "../components/ConfirmDialog";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import {
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import CustomTableHead from "../components/CustomTableHead";
import PopupMessage from "../components/PopupMessage";
import ViewPdf from "../components/ViewPdf";
import downloadjs from "downloadjs";
import SuspectItemDetails from "../details/SuspectItemDetails";

import ScrubIcon from "@material-ui/icons/VisibilityOutlined";

import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import PayIcon from "@material-ui/icons/CheckOutlined";
import ReturnIcon from "@material-ui/icons/CloseOutlined";
import DownloadFileIcon from "@material-ui/icons/MoveToInboxOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";

import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },

  vCenterItems: {
    display: "flex",
    alignItems: "center",
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

const columnData = [
  { id: "1", numeric: false, disablePadding: false, label: "Date" },
  { id: "2", numeric: false, disablePadding: false, label: "Trace" },
  { id: "3", numeric: false, disablePadding: false, label: "Check No." },
  { id: "4", numeric: true, disablePadding: false, label: "Amount($)" },
  { id: "5", numeric: false, disablePadding: false, label: "Payee" },
  { id: "6", numeric: false, disablePadding: false, label: "Status" },
  { id: "7", numeric: false, disablePadding: false, label: "Reason Rejected" },
];

class RejectedAccountItemsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      checkFrom: "",
      checkTo: "",
      amountFrom: "",
      amountTo: "",
      payee: "",
      items: [],
      totalAmount: "",
      selectedItemId: 0,
      selectedItemObject: {},
      order: "asc",
      orderBy: "4",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      totalCount: 0,
      canSearch: false,
      selectedReason: "-1",
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      backendStartDate: "",
      backendEndDate: "",
      waitingDownload: false,
      validated: false,
      viewPdf: false,
      radioValue: "3",
      collapsedSearch: false,
      scrub: false,
      notes: "",
      returnCode: "",
      payDisposition: true,
      confirmDisposition: false,
      rerunSearch: false,
      validateOnly: false,
      searchItemsInProgress: false,
      viewPopup: false,
      selectedSort: "1",      
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onDisposition = this.onDisposition.bind(this);
    this.handleBulkDisposition = this.handleBulkDisposition.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }
       
  handleSort(e) {
    this.setState({ selectedSort: e.target.value });
    if (e.target.value === "1") {
      this.setState({ orderBy: "4" });
    }          
    if (e.target.value === "2") {
      this.setState({ orderBy: "5" });
    }
    if (e.target.value === "3") {
      this.setState({ orderBy: "0" });
    }	
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
    if (this.state.waitingDownload && this.state.validated) {
      this.setState({ validated: false });
      this.setState({ waitingDownload: false });
      let myUrl = this.getUrl(
        "on_download_file",
        this.state.rowsPerPage,
        this.state.page,
        this.state.order,
        this.state.orderBy,
        true
      );
      this.downloadFile(myUrl, true);
    }
  }

  handleBulkNotes(e) {
    this.setState({ notes: e.target.value });
  }

  validateBulkData() {
    // no pending items allowed for bulk decisions
    for (let i = 0; i < this.state.items.length; i++) {
      let status = this.state.items[i].status;
      if (status === "P1" || status === "P2") {
        this.setState({
          errorString: getErrorString(
            "decision.bulk.error",
            "Bulk decisions are not allowed on pending items. Please decision any pending items."
          ),
        });
        this.setState({ viewPopup: true });
        return false;
      }
    }
    return true;
  }

  handleBulkPay(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (!this.validateBulkData()) {
      return;
    }
    this.setState({ payDisposition: true });
    this.setState({ confirmDisposition: true });
  }

  handleBulkReturn(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (!this.validateBulkData()) {
      return;
    }
    if (this.state.returnCode === "000" || this.state.returnCode.length === 0) {
      this.setState({
        errorString: getErrorString(
          "disposition.reason.error",
          "Return Reason is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ payDisposition: false });
    this.setState({ confirmDisposition: true });
  }

  handleBulkReturnCode(e) {
    this.setState({ returnCode: e.target.value });
  }
  handleBulkDisposition(e, action) {
    this.setState({ confirmDisposition: false });
    // confirmed
    if (action === 1) {
      fetch("on_bulk_disposition_request", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.props.accountObject.transit,
          account: this.props.accountObject.account,
          type: this.props.accountObject.accountType,
          pay: this.state.payDisposition,
          comment: this.state.notes,
          items: this.state.items,
          returnCode: this.state.returnCode,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            this.setState({ notifyString: "The action data have been saved." });
            this.setState({ page: 0 });
            this.setState({ rerunSearch: true });
            this.setState({ viewPopup: true });
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
          this.setState({ viewPopup: true });
        });
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
    this.setState({ searchItemsInProgress: false });
  }

  handleSearch(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ canSearch: true });
    this.setState({ validateOnly: false });
    this.setState({ searchItemsInProgress: true });
    let myUrl = this.getUrl(
      "on_search_rejected_items_request",
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      false
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      false
    );
  }

  handleScrub(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ validateOnly: false });
    this.setState({ scrub: true });

    // this.search(myUrl, false);
  }

  handlePdf(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  handleDownload(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ waitingDownload: true });
    this.setState({ validated: false });
    this.setState({ validateOnly: true });
    let myUrl = this.getUrl(
      "on_search_rejected_items_request",
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      true
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      true
    );
  }

  validateDates() {
    let start = this.state.startDate;
    let end = this.state.endDate;
    if (start !== null && end !== null && end.isBefore(start, "day")) {
      this.setState({
        errorString: getErrorString(
          "general.error.endDate",
          "End Date is before Start Date"
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  downloadFile(myUrl, validate) {
    //let validateOnly = validate === true ? 'yes' : null;
    let sortorder = this.state.order === "asc" ? 1 : 2;
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        option: this.props.option.id,
        sortorder: sortorder,
        sorttype: this.state.orderBy,
        startDate: this.state.backendStartDate,
        endDate: this.state.backendEndDate,
        reason: this.state.selectedReason,
        checkFrom: this.state.checkFrom,
        checkTo: this.state.checkTo,
        amountFrom: this.state.amountFrom,
        amountTo: this.state.amountTo,
        payee: this.state.payee,
        rowsPerPage: this.state.rowsPerPage,
        page: this.state.page,
        validateOnly: this.state.validateOnly,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.blob())
      .then((blob) => {
        downloadjs(blob, "itemfile.zip", "application/zip");
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleCollapse = (event) => {
    this.setState({ collapsedSearch: !this.state.collapsedSearch });
  };

  handleRadioChange = (event) => {
    this.disableSearch();
    this.setState({ radioValue: event.target.value });
  };

  handleStartDate(date) {
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleCheckFrom(e) {
    this.disableSearch();
    this.setState({ checkFrom: e.target.value });
  }

  handleCheckTo(e) {
    this.disableSearch();
    this.setState({ checkTo: e.target.value });
  }

  handleAmountFrom(e) {
    this.disableSearch();
    this.setState({ amountFrom: e.target.value });
  }

  handleAmountTo(e) {
    this.disableSearch();
    this.setState({ amountTo: e.target.value });
  }

  handlePayee(e) {
    this.disableSearch();
    this.setState({ payee: e.target.value });
  }

  handleReason(e) {
    this.disableSearch();
    this.setState({ selectedReason: e.target.value });
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    if (this.state.canSearch) {
      this.setState({ validateOnly: false });
      let myUrl = this.getUrl(
        "on_search_rejected_items_request",
        e.target.value,
        0,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        e.target.value,
        0,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    if (this.state.canSearch) {
      this.setState({ validateOnly: false });
      let myUrl = this.getUrl(
        "on_search_rejected_items_request",
        this.state.rowsPerPage,
        page,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        this.state.rowsPerPage,
        page,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.setState({ validateOnly: false });
    let myUrl = this.getUrl(
      "on_search_rejected_items_request",
      this.state.rowsPerPage,
      this.state.page,
      order,
      orderBy,
      false
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      order,
      orderBy,
      false
    );
  };

  handleSelectItem(event, itemKey) {
    this.setState({ selectedItemObject: this.state.items[itemKey - 1] });
    this.setState({ selectedItemId: itemKey });
  }

  getUrl(requestType, curRowsPerPage, curPage, order, orderBy, validateOnly) {
    return requestType;
    /*let myUrl = this.getBaseUrl(requestType, order, orderBy) +
			'&r=' + new Date().getTime() +
			'&token=' + this.props.secureToken +
			'&rowsPerPage=' + curRowsPerPage +
			'&page=' + curPage;
		if (validateOnly) {
			myUrl += '&validateOnly=yes'
		}
		return myUrl;*/
  }

  getBaseUrl(requestType, order, orderBy) {
    return requestType;
    /*let sortorder = order === 'asc' ? 1 : 2;
		let baseUrl = requestType + '?transit=' +
			this.props.accountObject.transit +
			'&account=' + this.props.accountObject.account +
			'&option=' + this.props.option.id +
			'&sortorder=' + sortorder +
			'&sorttype=' + orderBy;
		if (this.state.backendStartDate.length > 0) {
			baseUrl += "&startDate=" + encodeURIComponent(this.state.backendStartDate);
		}
		if (this.state.backendEndDate.length > 0) {
			baseUrl += "&endDate=" + encodeURIComponent(this.state.backendEndDate);
		}
		if (this.state.selectedReason !== '-1') {
			baseUrl += "&reason=" + encodeURIComponent(this.state.selectedReason);
		}
		if (this.state.checkFrom.length > 0) {
			baseUrl += "&checkFrom=" + encodeURIComponent(this.state.checkFrom);
		}
		if (this.state.checkTo.length > 0) {
			baseUrl += "&checkTo=" + encodeURIComponent(this.state.checkTo);
		}
		if (this.state.amountFrom.length > 0) {
			baseUrl += "&amountFrom=" + encodeURIComponent(this.state.amountFrom);
		}
		if (this.state.amountTo.length > 0) {
			baseUrl += "&amountTo=" + encodeURIComponent(this.state.amountTo);
		}
		if (this.state.payee.length > 0) {
			baseUrl += "&payee=" + encodeURIComponent(this.state.payee);
		}
		return baseUrl;*/
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ waitingDownload: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ scrub: false });
    this.setState({ selectedItemId: 0 });
    if (this.state.rerunSearch) {
      this.setState({ rerunSearch: false });
      this.setState({ validateOnly: false });
      let myUrl = this.getUrl(
        "on_search_rejected_items_request",
        this.state.rowsPerPage,
        this.state.page,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        this.state.rowsPerPage,
        this.state.page,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  }

  onDisposition(e) {
    this.setState({ scrub: false });
    this.setState({ selectedItemId: 0 });
    if (this.state.totalCount !== 0) {
      this.setState({ validateOnly: false });
      let myUrl = this.getUrl(
        "on_search_rejected_items_request",
        this.state.rowsPerPage,
        this.state.page,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        this.state.rowsPerPage,
        this.state.page,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  }

  getCriteriaObject(rowsPerPage, page) {
    let validateOnly = this.state.validateOnly === true ? "yes" : null;
    let sortorder = this.state.order === "asc" ? 1 : 2;
    let data = {
      r: new Date().getTime(),
      secureToken: this.props.secureToken,
      transit: this.props.accountObject.transit,
      account: this.props.accountObject.account,
      option: this.props.option.id,
      sortorder: sortorder,
      sorttype: this.state.orderBy,
      startDate: this.state.backendStartDate,
      endDate: this.state.backendEndDate,
      reason: this.state.selectedReason,
      checkFrom: this.state.checkFrom,
      checkTo: this.state.checkTo,
      amountFrom: this.state.amountFrom,
      amountTo: this.state.amountTo,
      payee: this.state.payee,
      rowsPerPage: rowsPerPage,
      page: page,
      validateOnly: validateOnly,
      scrub: this.state.scrub === true ? "yes" : "false",
    };
    return data;
  }

  search(myUrl, rowsPerPage, page, order, orderBy, validate) {
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.getCriteriaObject(rowsPerPage, page)),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ searchItemsInProgress: false });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            if (validate) {
              this.setState({ validated: true });
            } else {
              let newItems = reply.items;
              this.setState({ items: newItems });
              this.setState({ totalCount: reply.totalCount });
              this.setState({ totalAmount: reply.totalAmount });
              if (reply.numItems === 0) {
                this.setState({ viewPopup: true });
                this.setState({
                  notifyString: getErrorString(
                    "general.info.search.empty",
                    "Total number of items is 0."
                  ),
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ searchItemsInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  isSelected = (id) => this.state.selectedItemId === id;

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const reasons = this.props.reasons;
    const { order, orderBy, rowsPerPage, page, totalCount } = this.state;
    const datePickerTopMargin = this.props.option.id === "O" ? 10 : 6;
    const actionTopMargin = this.props.option.id === "O" ? 4 : 0;
    let data = this.state.items;
    let options = this.props.reports;
    let myPdfUrl = this.getBaseUrl("on_search_rejected_items_pdf_request");

    return (
      <div>
        {this.state.confirmDisposition && (
          <ConfirmDialog
            title={
              this.state.payDisposition
                ? t("confirmBulkPay.label")
                : t("confirmBulkReturn.label")
            }
            text={
              this.state.payDisposition
                ? t("payBulkQuestion.label")
                : t("returnBulkQuestion.label")
            }
            onCloseConfirm={this.handleBulkDisposition}
          />
        )}
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            pdfUrl={myPdfUrl}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.scrub && (
          <div>
            <SuspectItemDetails
              scrub={true}
              fromHome={false}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              history={this.props.history}
              accountObject={this.props.accountObject}
              onClosePopup={this.onClosePopup}
              returnCodes={this.props.returnCodes}
              onDisposition={this.onDisposition}
              option={this.props.option}
              url={this.getUrl(
                "on_search_rejected_items_request",
                this.state.rowsPerPage,
                this.state.page,
                this.state.order,
                this.state.orderBy,
                false
              )}
            />
          </div>
        )}
        {this.state.selectedItemId !== 0 && (
          <div>
            <SuspectItemDetails
              scrub={false}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              item={this.state.selectedItemObject}
              history={this.props.history}
              accountObject={this.props.accountObject}
              onClosePopup={this.onClosePopup}
              returnCodes={this.props.returnCodes}
              onDisposition={this.onDisposition}
              option={this.props.option}
            />
          </div>
        )}

        {this.state.selectedItemId === 0 && !this.state.scrub && (
          <div>
            <div>
              <Paper elevation={5}>
                <FormGroup row>
                  <div>
                    <Typography variant="caption">
                      {t("report.label")}&nbsp;&nbsp;
                    </Typography>
                    <FormControl>
                      <NativeSelect
                        style={{
                          height: 48,
                          verticalAlign: "textTop",
                          margin: 0,
                        }}
                        defaultValue={this.props.option.index}
                        input={<Input id="report_options" />}
                        onChange={(event) => this.handleChange(event)}
                      >
                        {options.map((n) => {
                          return (
                            <option value={n.index}>{n.description}</option>
                          );
                        })}
                      </NativeSelect>
                    </FormControl>
                    &nbsp;&nbsp;
                  </div>
                  {this.props.option.id === "O" && (
                    <div>
                      <Typography variant="caption">
                        {t("outstandingItemType.label")}
                      </Typography>
                      <div>
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              color="default"
                              checked={this.state.radioValue === "1"}
                              onChange={this.handleRadioChange}
                              value="1"
                              name="radioButton"
                            />
                          }
                          label={t("issue.label")}
                        />
                        <FormControlLabel
                          value="2"
                          control={
                            <Radio
                              color="default"
                              checked={this.state.radioValue === "2"}
                              onChange={this.handleRadioChange}
                              value="2"
                              name="radioButton"
                            />
                          }
                          label={t("void.label")}
                        />
                        <FormControlLabel
                          value="3"
                          control={
                            <Radio
                              color="default"
                              checked={this.state.radioValue === "3"}
                              onChange={this.handleRadioChange}
                              value="3"
                              name="radioButton"
                            />
                          }
                          label={t("both.label")}
                        />
                      </div>
                    </div>
                  )}
                  {!this.props.option.disableReason && (
                    <div>
                      <Typography variant="caption">
                        {t("exceptionReason.label")}&nbsp;&nbsp;
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 48,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.selectedReason}
                          input={<Input id="reason_options" />}
                          onChange={(event) => this.handleReason(event)}
                        >
                          {reasons.map((n) => {
                            return (
                              <option value={n.id}>{n.description}</option>
                            );
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                  )}
                  {!this.props.option.disableStartDate && (
                    <div>
                      <Typography variant="caption">
                        {t("startDate.label")}
                        {!this.state.redrawStartDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.startDate}
                              onChange={(event) => this.handleStartDate(event)}
                              onClickOutside={(event) =>
                                this.handleStartDateOutsideClick(event)
                              }
                              popperContainer={CalendarContainer}
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                  )}
                  &nbsp;&nbsp;
                  {!this.props.option.disableEndDate && (
                    <div>
                      <Typography variant="caption">
                        {t("endDate.label")}
                        {!this.state.redrawEndDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.endDate}
                              onChange={(event) => this.handleEndDate(event)}
                              onClickOutside={(event) =>
                                this.handleEndDateOutsideClick(event)
                              }
                              popperContainer={CalendarContainer}
                            />
                          </div>
                        )}
                      </Typography>
                      &nbsp;&nbsp;
                    </div>
                  )}
                   <div>
                     <Typography variant="caption">
                       {t("sort.label")}&nbsp;&nbsp;
                     </Typography>
                     <FormControl>
                       <NativeSelect
                          style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                          defaultValue={this.state.selectedSort}
                          input={<Input id="sort_options" />}
                          onChange={(event) => this.handleSort(event)}
                        >                      
                          <option value="1">{t("amount.label")}</option>
                          <option value="2">{t("payee.label")}</option>
                          <option value="3">{t("default.label")}</option>  
                        </NativeSelect>
                     </FormControl>
                     &nbsp;&nbsp;
                   </div>                                      
                  {this.props.option.controlDisabled === false && (
                    <Tooltip
                      title={
                        t("showSearchResult.tip") +
                        this.props.option.description
                      }
                    >
                      <Button
                        color="primary"
                        style={{ marginTop: actionTopMargin }}
                        onClick={(event) => this.handleSearch(event)}
                      >
                        <SearchIcon />
                        &nbsp;{t("search.button")}
                      </Button>
                    </Tooltip>
                  )}
                  {this.props.option.controlDisabled === true && (
                    <Typography variant="body1" color="error">
                      {t("suspectReviewNotAvi.label")}{" "}
                      <strong> {-this.props.scrubTimeLeft} </strong>{" "}
                      {t("minutesAs.label")}
                      {this.props.crtTime}).
                    </Typography>
                  )}
                  {!this.props.option.disablePdf && (
                    <Tooltip title={t("viewPdfReport.tip")}>
                      <Button
                        color="primary"
                        style={{ marginTop: actionTopMargin }}
                        onClick={(event) => this.handlePdf(event)}
                      >
                        <PDFViewIcon />
                        &nbsp;{t("pdf.button")}
                      </Button>
                    </Tooltip>
                  )}
                  {!this.props.option.disableFileDownload &&
                    this.props.option.controlDisabled === false && (
                      <Tooltip title={t("downLoadItemsFile.tip")}>
                        <Button
                          color="primary"
                          style={{ marginTop: actionTopMargin }}
                          onClick={(event) => this.handleDownload(event)}
                        >
                          <DownloadFileIcon />
                          &nbsp;{t("download.button")}
                        </Button>
                      </Tooltip>
                    )}
                  {this.props.option.id === "N" &&
                    this.props.option.controlDisabled === false && (
                      <Tooltip title={t("scrubSuspects.tip")}>
                        <Button
                          color="primary"
                          style={{ marginTop: actionTopMargin }}
                          onClick={(event) => this.handleScrub(event)}
                        >
                          <ScrubIcon />
                          &nbsp;{t("scrub.button")}
                        </Button>
                      </Tooltip>
                    )}
                  {!this.state.collapsedSearch && (
                    <Tooltip title={t("collaspSearch.tip")}>
                      <IconButton
                        style={{ position: "absolute", right: 10, top: 0 }}
                        onClick={(event) => this.handleCollapse(event)}
                      >
                        <ArrowDropUp />
                      </IconButton>
                    </Tooltip>
                  )}
                  {this.state.collapsedSearch && (
                    <Tooltip title={t("expandSearch.tip")}>
                      <IconButton
                        style={{ position: "absolute", right: 10, top: 0 }}
                        onClick={(event) => this.handleCollapse(event)}
                      >
                        <ArrowDropDown />
                      </IconButton>
                    </Tooltip>
                  )}
                </FormGroup>

                {!this.state.collapsedSearch && (
                  <FormGroup row>
                    {!this.props.option.disableFromCheck && (
                      <TextField
                        margin="dense"
                        id="checkFrom"
                        label={t("checkNoFrom.label")}
                        type="text"
                        defaultValue={this.state.checkFrom}
                        onChange={(event) => this.handleCheckFrom(event)}
                        onKeyPress={(event) => {
                          return event.charCode >= 48 && event.charCode <= 57
                            ? true
                            : event.preventDefault();
                        }}
                      />
                    )}
                    &nbsp;&nbsp;
                    {!this.props.option.disableToCheck && (
                      <TextField
                        margin="dense"
                        id="checkTo"
                        label={t("checkNoTo.label")}
                        type="text"
                        defaultValue={this.state.checkTo}
                        onChange={(event) => this.handleCheckTo(event)}
                        onKeyPress={(event) => {
                          return event.charCode >= 48 && event.charCode <= 57
                            ? true
                            : event.preventDefault();
                        }}
                      />
                    )}
                    &nbsp;&nbsp;
                    {!this.props.option.disableFromAmount && (
                      <TextField
                        margin="dense"
                        id="amountFrom"
                        label={t("amountFrom.label")}
                        type="text"
                        defaultValue={this.state.amountFrom}
                        onChange={(event) => this.handleAmountFrom(event)}
                        InputProps={{
                          inputComponent: AmountFormatCustom,
                        }}
                      />
                    )}
                    &nbsp;&nbsp;
                    {!this.props.option.disableToAmount && (
                      <TextField
                        margin="dense"
                        id="amountTo"
                        label={t("amountTo.label")}
                        type="text"
                        defaultValue={this.state.amountTo}
                        onChange={(event) => this.handleAmountTo(event)}
                        InputProps={{
                          inputComponent: AmountFormatCustom,
                        }}
                      />
                    )}
                    &nbsp;&nbsp;
                    {!this.props.option.disableePayee && (
                      <TextField
                        margin="dense"
                        id="payee"
                        label={t("payeeName.label")}
                        defaultValue={this.state.payee}
                        onChange={(event) => this.handlePayee(event)}
                      />
                    )}
                  </FormGroup>
                )}
              </Paper>
            </div>

            <Divider />
            {this.state.selectedItemId === 0 &&
              this.state.errorString.length === 0 &&
              this.state.searchItemsInProgress && (
                <div className={classes.tableWrapper}>
                  <CircularProgress className={classes.progress} />
                </div>
              )}
            <TablePagination
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={(event) =>
                this.handleChangeRowsPerPage(event)
              }
              ActionsComponent={CustomPaginatorActions}
            />
            {this.state.canSearch &&
              this.state.selectedItemId === 0 &&
              this.state.totalCount > 0 &&
              !this.state.scrub && (
                <div>
                  <Paper elevation={5}>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      stickyHeader
                    >
                      <CustomTableHead
                        order={order}
                        orderBy={orderBy}
                        columnData={columnData}
                        onRequestSort={this.handleRequestSort}
                      />
                      <TableBody>
                        {data.map((n) => {
                          const isSelected = this.isSelected(n.index);
                          return (
                            <TableRow
                              hover
                              className={classes.tableRow}
                              onClick={(event) =>
                                this.handleSelectItem(event, n.index)
                              }
                              key={n.index}
                              selected={isSelected}
                              title={t("clickSelectItem.label")}
                            >
                              <TableCell style={{ width: "8%" }}>
                                {n.date}
                              </TableCell>
                              <TableCell style={{ width: "10%" }}>
                                {n.trace}
                              </TableCell>
                              <TableCell style={{ width: "12%" }}>
                                {n.checkNumber}
                              </TableCell>
                              <TableCell
                                numeric={true}
                                style={{ width: "10%" }}
                              >
                                {n.amount}
                              </TableCell>
                              <TableCell
                                style={{ width: "36%", wordWrap: "break-word" }}
                              >
                                {n.payee}
                              </TableCell>
                              <TableCell style={{ width: "12%" }}>
                                {n.statusDescr}
                              </TableCell>
                              <TableCell style={{ width: "12%" }}>
                                {n.reasonRejected}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                      {this.state.totalCount > 0 && (
                        <TableFooter className={classes.boldCell}>
                          <TableRow>
                            <TableCell colSpan={3} className={classes.boldCell}>
                              {t("totalAmount.label")} {this.state.totalAmount}
                            </TableCell>
                          </TableRow>
                        </TableFooter>
                      )}
                    </Table>
                  </Paper>
                  {this.props.option.id === "N" && (
                    <div style={{ marginTop: 30 }}>
                      <Paper elevation={5}>
                        <FormGroup row>
                          <p>
                            &nbsp;&nbsp;
                            <strong>{t("bulkDecisions.label")}</strong>
                            &nbsp;&nbsp;&nbsp;
                          </p>
                          <Tooltip title={t("payAllItem.tip")}>
                            <Button
                              color="primary"
                              onClick={(event) => this.handleBulkPay(event)}
                            >
                              <PayIcon />
                              &nbsp;{t("pay.label")}
                            </Button>
                          </Tooltip>
                          <Tooltip title={t("returnAllItem.tip")}>
                            <Button
                              color="primary"
                              onClick={(event) => this.handleBulkReturn(event)}
                            >
                              <ReturnIcon />
                              &nbsp;{t("return.label")}
                            </Button>
                          </Tooltip>
                          <Typography
                            style={{ marginBottom: 0 }}
                            variant="caption"
                          >
                            {t("returnReason.label")}&nbsp;&nbsp;
                          </Typography>
                          <FormControl>
                            <NativeSelect
                              style={{
                                height: 48,
                                verticalAlign: "textTop",
                                margin: 0,
                              }}
                              defaultValue={this.state.returnCode}
                              input={<Input id="return_code" />}
                              onChange={(event) =>
                                this.handleBulkReturnCode(event)
                              }
                            >
                              {this.props.returnCodes.map((n) => {
                                return (
                                  <option value={n.id}>{n.description}</option>
                                );
                              })}
                            </NativeSelect>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row>
                          &nbsp;&nbsp;
                          <div>
                            <TextField
                              margin="dense"
                              id="notes"
                              label={t("notes.label")}
                              onChange={(event) => this.handleBulkNotes(event)}
                            />
                          </div>
                        </FormGroup>
                      </Paper>
                      <Divider />
                    </div>
                  )}
                </div>
              )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(RejectedAccountItemsPage));
